import {createContext} from '@chakra-ui/react-context';
import type {PopoverProps} from '@chakra-ui/react';
import {Popover as ChakraPopover} from '@chakra-ui/react';
import {useFormContext} from 'react-hook-form';
import type {Dispatch, SetStateAction} from 'react';
import {useEffect, useMemo, useState} from 'react';

export type PopoverFormContextState = {isValid: boolean; isDirty: boolean};
export const defaultPopoverFormState: PopoverFormContextState = {isValid: false, isDirty: false};

export type PopoverFormContextProps = {
  state: PopoverFormContextState;
  setState: Dispatch<SetStateAction<PopoverFormContextState>>;
};

export const [PopoverFormProvider, usePopoverForm] = createContext<PopoverFormContextProps>({
  name: `PopoverFormContext`,
  errorMessage: `usePopoverForm returned is 'undefined'. Seems you forgot to wrap the components in "<PopoverFormProvider />" `,
});

export const Popover = (props: PopoverProps) => {
  const [state, setState] = useState<PopoverFormContextState>(defaultPopoverFormState);
  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [state, setState],
  );
  const isLocked = state.isDirty;

  return (
    <PopoverFormProvider value={value}>
      <ChakraPopover closeOnBlur={!isLocked} closeOnEsc={!isLocked} {...props} />
    </PopoverFormProvider>
  );
};

export const PopoverFormStateConsumer = () => {
  const {
    formState: {isValid, isDirty},
  } = useFormContext();
  const {setState} = usePopoverForm();

  useEffect(() => {
    setState({isValid, isDirty});
  }, [isValid, isDirty, setState]);

  return null;
};
